import type { Conversation, Message } from "./types";

export const conversations: Conversation[] = [
  {
    id: "health-plan",
    title: "오늘 운동 계획",
    preview: "회복 상태를 기준으로 강도를 조절했어요.",
    updatedAt: "방금",
    source: "webui",
  },
  {
    id: "morning-brief",
    title: "아침 브리핑",
    preview: "오후 일정 전까지 집중 시간이 있어요.",
    updatedAt: "08:04",
    source: "webui",
  },
  {
    id: "paper-digest",
    title: "이번 주 논문 다이제스트",
    preview: "Differentiable scheduling 논문 3편을 골랐어요.",
    updatedAt: "어제",
    source: "webui",
  },
  {
    id: "meal-plan",
    title: "일주일 식단 구성",
    preview: "바쁜 날을 위한 대체 식사까지 포함했어요.",
    updatedAt: "금요일",
    source: "webui",
  },
];

export const initialMessages: Record<string, Message[]> = {
  "health-plan": [
    {
      id: "m1",
      role: "user",
      content: "오늘 운동은 어떻게 하는 게 좋을까? 어제 하체를 했고 잠은 6시간 정도 잤어.",
      createdAt: "오전 9:42",
    },
    {
      id: "m2",
      role: "assistant",
      content:
        "오늘은 **상체 중심의 중간 강도 세션**이 좋아 보여요. 수면이 조금 부족하니 실패 지점까지 밀기보다 2–3회 정도 여유를 남겨두세요.\n\n### 추천 루틴\n\n1. 인클라인 덤벨 프레스 — 3세트 × 8–10회\n2. 랫풀다운 — 3세트 × 10–12회\n3. 시티드 숄더 프레스 — 2세트 × 10회\n4. 케이블 로우 — 3세트 × 10–12회\n5. 가벼운 코어 — 8분\n\n전체 운동은 **45–55분**, 목표 RPE는 `7` 정도로 잡을게요. 워밍업 중 몸이 무겁다면 메인 세트를 한 세트씩 줄여도 충분합니다.",
      createdAt: "오전 9:43",
    },
  ],
  "morning-brief": [],
  "paper-digest": [],
  "meal-plan": [],
};

export const starterPrompts = [
  { eyebrow: "Plan", text: "오늘 계획을 현실적으로 정리해줘" },
  { eyebrow: "Reflect", text: "최근 기록에서 중요한 흐름을 찾아줘" },
  { eyebrow: "Explore", text: "지금 떠오른 아이디어를 같이 발전시켜줘" },
];

export const demoResponse =
  "좋아요. 지금까지의 맥락을 바탕으로 가장 중요한 것부터 정리해볼게요. 먼저 오늘 반드시 끝내야 하는 한 가지를 정하고, 나머지는 에너지 수준에 맞춰 배치하는 편이 좋습니다. 원하면 제가 바로 실행 가능한 체크리스트로 바꿔드릴게요.";
